module.exports = __webpack_public_path__ + "img/gokvi-logo.3110eb84.png";